import Polish from './i18n.pl-pl';
import English from './i18n.en-en';
import Vue from 'vue';
import VueI18n from "vue-i18n";
import {RouteName} from "@/router";
import {Location} from "vue-router";
import {Dictionary} from "vue-router/types/router";

const messages = {
    pl: Polish,
    en: English
};

Vue.use(VueI18n);

export const availableLocales = ['pl', 'en'];

export const defaultLocale = 'pl';

const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: defaultLocale,
    messages
});

export function localizedRoute(route: RouteName, params?: Dictionary<string>, hash?: string): Location {
    return {name: route, params: {...params, locale: i18n.locale}, hash};
}

export default i18n;
